const state = {
	/**
	 * 黑名单
	 */
	isUpdated: false,
	blackState: 'common',
	/**
	 * 宿舍管理
	 */
	isChanged: false, // 宿舍信息是否被修改/删除。
	isFromRoom: false, // 住宿生页面——是否从宿舍房间页面跳转而来
	isFromDorm: false, // 宿舍房间页面——是否从宿舍楼页面跳转而来
	selectData: {} // 筛选的信息
};
export default state;
